import { useEffect } from 'react';

const DESKTOP_WIDTH = 1200; // adjust as needed

export const useDesktopViewport = () => {
  useEffect(() => {
    const meta = document.querySelector('meta[name="viewport"]');
    const originalContent = meta ? meta.content : 'width=device-width, initial-scale=1.0';

    if (meta) {
      meta.content = `width=${DESKTOP_WIDTH}, initial-scale=1.0`;
    } else {
      const newMeta = document.createElement('meta');
      newMeta.name = 'viewport';
      newMeta.content = `width=${DESKTOP_WIDTH}, initial-scale=1.0`;
      document.head.appendChild(newMeta);
    }

    // Restore original viewport when leaving the page
    return () => {
      const meta = document.querySelector('meta[name="viewport"]');
      if (meta) {
        meta.content = originalContent;
      }
    };
  }, []);
};